const state = {
  tags: [],
};

const mutations = {
  ADD_TAG(state, tag) {
    state.tags.push(tag);
  },
  CHANGE_SELECTED_TAG(state, tag) {
    state.selectedTag = tag;
  },
};

const actions = {

  downloadTag({ commit }, tag) {
    return new Promise(resolve =>
      this.state.Database.db
        .collection("tags")
        .doc(tag)
        .get()
        .then(doc => {
          const tagsTemp = doc.data();
          tagsTemp.id = doc.id;
          this.state.Database.storage.refFromURL(tagsTemp.icon).getDownloadURL().then(url => {
            const xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.open("GET", url);
            xhr.send();
            tagsTemp.imageUrl = url;
            commit("ADD_TAG", tagsTemp);
            resolve(true);
          }).catch(console.error);
        }));
  },
  changeSelectedTag({ commit }, tagId) {
    commit("CHANGE_SELECTED_TAG", tagId);
  }
};

const getters = {
  getTags(state) {
    return state.tags;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}; 



// WEBPACK FOOTER //
// ./src/store/modules/Tags.js